import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyScheduleCalendarSadFace = lazy(() => import('./svg-components/schedule-calendar-sad-face'));

const ScheduleCalendarSadFace = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyScheduleCalendarSadFace {...rest} />
  </Suspense>
);

export default ScheduleCalendarSadFace;
